module.exports = __webpack_public_path__ + "static/img/TZ.0fdf91f7.png";